import React, { useState } from 'react'
import { useUpdateEffect } from 'genesis-suite/hooks'
import produce from 'immer'
import { v1 as uuid } from 'uuid'
import NodeSelector from './NodeSelector'
import EditableList from '../EditableList'
import { nodeRoleOptions } from './NodeRoleOptions'

const NodePermissionController = ({ defaultRows, onChange, options }) => {
    const [rows, setRows] = useState(defaultRows)

    useUpdateEffect(() => {
        onChange(rows)
    }, [rows])

    const handleRowRemove = i =>
        setRows(
            produce(rows, draft => {
                draft.splice(i, 1)
            })
        )
    const handleRowAdd = () => setRows([...rows, { id: uuid() }])
    const handleChange = (val, id, type) => {
        if (type === 'node') {
            /* eslint-disable no-unused-vars */
            setRows(
                produce(rows, draft => {
                    draft = draft.map(row => {
                        if (row.id === id) row.node = val
                        return row
                    })
                })
            )
        } else {
            setRows(
                produce(rows, draft => {
                    draft = draft.map(row => {
                        if (row.id === id) row.role = val
                        return row
                    })
                })
            )
        }
    }

    return (
        <EditableList onRemove={handleRowRemove} onAdd={handleRowAdd}>
            {rows &&
                rows.map(row => (
                    <>
                        <NodeSelector
                            id={row.id}
                            key={row.id}
                            onChange={handleChange}
                            defaultNode={row.node}
                            defaultRole={nodeRoleOptions.find(role => role.value === row.role)}
                            options={options}
                            roleOptions={nodeRoleOptions}
                        />
                    </>
                ))}
        </EditableList>
    )
}

export default NodePermissionController
